import { Link } from 'react-router-dom'
import { MenuLinks } from '@/constants/menu'
import { BrandingDetails } from '@/constants'
import BrandLogo from '@/components/BrandLogo/BrandLogo'

const MarketingFooter = () => {
	return (
		<footer className="mt-24 border-t border-border/60">
			<div className="container grid gap-10 py-12 md:grid-cols-4">
				<div className="md:col-span-2">
					<BrandLogo linkTo="/" size="sm" tone="default" />
					<p className="mt-4 max-w-sm text-sm text-muted-foreground">{BrandingDetails.CLIENT_NAME} — database documentation, licensing, and administration. Built for teams who care about clarity and control.</p>
				</div>
				<div>
					<h4 className="mb-3 text-sm font-semibold text-foreground">Product</h4>
					<ul className="space-y-2 text-sm text-muted-foreground">
						<li>
							<Link to="/#features" className="hover:text-foreground">
								Features
							</Link>
						</li>
						<li>
							<Link to={MenuLinks.PublicPricing} className="hover:text-foreground">
								Pricing
							</Link>
						</li>
						<li>
							<Link to={MenuLinks.PublicPricing} className="hover:text-foreground">
								Buy
							</Link>
						</li>
					</ul>
				</div>
				<div>
					<h4 className="mb-3 text-sm font-semibold text-foreground">Account</h4>
					<ul className="space-y-2 text-sm text-muted-foreground">
						<li>
							<Link to={MenuLinks.Login} className="hover:text-foreground">
								Sign in
							</Link>
						</li>
						<li>
							<Link to={MenuLinks.Dashboard} className="hover:text-foreground">
								App
							</Link>
						</li>
						<li>
							<Link to={MenuLinks.ViewAdministratorSubMenu} className="hover:text-foreground">
								Administrator
							</Link>
						</li>
					</ul>
				</div>
			</div>
			<div className="border-t border-border/60 py-6">
				<div className="container flex flex-col items-center justify-between gap-2 text-xs text-muted-foreground md:flex-row">
					<span>
						© {new Date().getFullYear()} {BrandingDetails.CLIENT_NAME}. All rights reserved.
					</span>
					<span className="font-mono">v1.0.0</span>
				</div>
			</div>
		</footer>
	)
}

export default MarketingFooter
